"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = require("./context");
var get_1 = __importDefault(require("lodash/fp/get"));
var map_1 = __importDefault(require("lodash/map"));
var find_1 = __importDefault(require("lodash/find"));
var zipObject_1 = __importDefault(require("lodash/zipObject"));
var FormValidationProvider = /** @class */ (function (_super) {
    __extends(FormValidationProvider, _super);
    function FormValidationProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validateFields = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.validateFields(this.state.values)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1.errors) {
                            this.actions.setAllErrors(e_1.errors);
                        }
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.validateField = function (name) { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.validateField(name, this.state.values[name], this.state.values)];
                    case 1:
                        _a.sent();
                        this.actions.setError(name, '');
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.actions.setError(name, e_2.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.actions = _this.buildActions();
        return _this;
    }
    FormValidationProvider.prototype.setTouched = function (name) {
        var _this = this;
        _super.prototype.setTouched.call(this, name, function () {
            _this.validateField(name);
        });
    };
    FormValidationProvider.prototype.setValue = function (name, value) {
        var _this = this;
        _super.prototype.setValue.call(this, name, value, function () {
            if (_this.state.touched[name]) {
                _this.validateField(name);
            }
            else {
                _this.actions.setError(name, '');
            }
        });
    };
    FormValidationProvider.prototype.buildActions = function () {
        return __assign(__assign({}, _super.prototype.buildActions.call(this)), { validateField: this.validateField, validateFields: this.validateFields });
    };
    return FormValidationProvider;
}(context_1.FormProvider));
exports.FormValidationProvider = FormValidationProvider;
function validateField(schema, path, value, values) {
    return __awaiter(this, void 0, void 0, function () {
        var e_3, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, schema.validate(values, {
                            abortEarly: false,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    message = (find_1.default(e_3.inner, { path: path }) || { message: null }).message;
                    if (message)
                        throw { message: message };
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.validateField = validateField;
function validateAllFields(schema, values) {
    return __awaiter(this, void 0, void 0, function () {
        var e_4, errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, schema.validate(values, {
                            abortEarly: false,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_4 = _a.sent();
                    errors = zipObject_1.default(map_1.default(e_4.inner, get_1.default('path')), map_1.default(e_4.inner, get_1.default('message')));
                    throw { message: e_4.message, errors: errors };
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.validateAllFields = validateAllFields;
//# sourceMappingURL=validate.js.map